import { apiCoupons } from './apiCoupons'
import { apiMarketingPromotions } from './apiMarketingPromotions'
import { apiPromotionActions } from './apiPromotionActions'
import { apiPromotionRules } from './apiPromotionRules'
import { apiPromotions } from './apiPromotions'

const apiPromo = {
	...apiPromotions,
	...apiPromotionActions,
	...apiPromotionRules,
	...apiCoupons,
	...apiMarketingPromotions,
}

export { apiPromo }
